<template>
  <v-layout justify-center>
    <v-flex>
      <text-field
        v-model.trim="form.name"
        :validator="vs.form.name"
        :label="adminText('workflowsAll.category_name_ed3dc45', 'Category name')"
      />
    </v-flex>

    <v-flex v-show="showDetails">
      <v-layout>
        <v-flex>
          <color-picker-field
            v-model="form.color"
            :validator="vs.form.color"
            :label="adminText('workflowsAll.color_1d0c830', 'Color')"
          />
        </v-flex>
        <v-flex>
          <zone-picker-field
            v-model="form.zones"
            :validator="vs.form.zones"
            :number-of-zones="numberOfZones"
            :label="adminText('workflowsAll.zones_182e2eb', 'Zones')"
          />
        </v-flex>
        <v-flex style="padding-top:17px;" class="m-0" shrink>
          <v-btn
            slot="activator"
            class="size-32"
            color="primary"
            icon
            @click="$emit('close'); showDetails=false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-show="!showDetails" align-self-center shrink>
      <v-btn
        slot="activator"
        :disabled="!form.name"
        class="size-32"
        color="primary"
        icon
        @click="openDetails"
      >
        <v-icon>arrow_forward</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

export default {
  mixins: [WorkflowDisplay],
  name: 'new-category-form',
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    reset: {
      type: Boolean,
      default: false,
    },
    numberOfZones: {
      type: Number,
      default: null,
    },
    vs: {
      type: Object,
      default: () => ({
        form: {},
      }),
    },
    withDetails: Boolean,
    onOpenReinitialize: Boolean,

  },
  data(){
    return {
      form: {
        color: '#000000',
        ...this.initialValues,
      },
      showDetails: this.withDetails,
    }
  },
  watch: {
    form: {
      handler(val){
        this.$emit('values', val)
      },
      deep: true,
    },
    initialValues: {
      handler(val) {
        if (val && val.id)
          this.form = { ...val }
      },
      deep: true,
    },
    reset(val) {
      if (val) {
        this.form = { color: '#000000' }
        this.showDetails = false
        this.vs.$reset()
        this.$emit('update:reset', !val)
      }
    },
  },
  methods: {
    openDetails(){
      this.$emit('open', this.form)
      if (this.onOpenReinitialize){
        this.form = {}
      } else {
        this.showDetails=true
      }
    },
  },
}
</script>

<style scoped>

</style>
